/* THIS FILE IS GENERATED. DO NOT EDIT */

import { PropsFromComponent } from '@/types/component';
import { withDebugMetadata } from '@/utils/withDebugMetadata';
import { withLabradorInstanceof } from '@/utils/withInstanceofProp';
import { LabradorLabradorImage as ResolvedLabradorLabradorImage } from 'base/components/labrador/LabradorImage';

export const LabradorLabradorImage: typeof ResolvedLabradorLabradorImage = withLabradorInstanceof((props) => {
    return <ResolvedLabradorLabradorImage {...props} {...withDebugMetadata({type: props.type, meta: props.meta})} />;
});

export type LabradorLabradorImageProps = PropsFromComponent<typeof LabradorLabradorImage>;
